import React, { Component } from 'react';
import dayjs from 'dayjs';

import services from '@C/Reports/_utils/data';
import { formatCurrency, TableGrid } from '@C/TableGrid';
import { FuelList, VendorList, DateRangeFilter } from '@C/Utils';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';

const col = [
  {
    name: 'Date',
    key: 'invoice_date',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Invoice number',
    key: 'invoice_number',
  },
  {
    name: 'Supplier Name',
    key: 'all',
    formatter(props) {
      return (
        <>
          {props.vendor_first_name} {props.vendor_last_name}
        </>
      );
    },
  },
  {
    name: 'Product',
    key: 'product',
  },
  {
    name: 'Quantity',
    key: 'total_quantity',
  },
  {
    name: 'Amount',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.base_amount)}</>;
    },
  },
  {
    name: 'Discount',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.discount)}</>;
    },
  },
  {
    name: 'VAT',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.vat)}</>;
    },
  },
  {
    name: 'Additional VAT',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.additional_vat)}</>;
    },
  },
  {
    name: 'Cess',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.cess)}</>;
    },
  },
  {
    name: 'Social sec cess',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.social_sec_cess)}</>;
    },
  },
  {
    name: 'Reverse dealer commission',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.reverse_dealer_commission)}</>;
    },
  },
  {
    name: 'Recovery for LFR/SSLF',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.recovery_for_lfr_sslf)}</>;
    },
  },
  {
    name: 'TCS Amount',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.tcs_amount)}</>;
    },
  },
  {
    name: 'Total amount',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.amount)}</>;
    },
  },
  {
    name: 'Notes',
    key: 'notes',
  },
];
class FuelPurchaseReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      purchaseList: [],
      product_id: '',
      vendor_id: '',
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      loading: false,
      limit: 20,
      offset: 1,
      count: 0,
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    //this.getFuelPurchase();
  }

  handleProductChange = (e) => {
    this.setState({ product_id: e.value });
  };

  handleVendorChange = (e) => {
    this.setState({ vendor_id: e?.value || '' }, function () {
      this.getFuelPurchase();
    });
  };

  getFuelPurchase = () => {
    services
      .getFuelPurchase(this.state)
      .then((response) => {
        this.setState({
          purchaseList: response.data.data.results,
          count: response.data.data.count,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handlePagination = (e) => {
    this.setState({ offset: e }, function () {
      this.getFuelPurchase();
    });
  };

  handleDateChange = (e) => {
    const { name, value } = e.target;
    const maxRangeMonths = 6;

    if (name === 'start_date') {
      const newStartDate = dayjs(value);
      const currentEndDate = dayjs(this.state.end_date);
      const maxEndDate = newStartDate.add(maxRangeMonths, 'month');

      // If new start date is after current end date, set end date to start date
      if (newStartDate.isAfter(currentEndDate)) {
        this.setState({ start_date: value, end_date: value });
      }
      // If end date exceeds 6 months from new start date, adjust end date
      else if (currentEndDate.isAfter(maxEndDate)) {
        this.setState({
          start_date: value,
          end_date: maxEndDate.format('YYYY-MM-DD'),
        });
      }
      // Otherwise just update start date
      else {
        this.setState({ start_date: value });
      }
    } else if (name === 'end_date') {
      const newEndDate = dayjs(value);
      const currentStartDate = dayjs(this.state.start_date);
      const minStartDate = newEndDate.subtract(maxRangeMonths, 'month');

      // If new end date is before current start date, set start date to end date
      if (newEndDate.isBefore(currentStartDate)) {
        this.setState({ end_date: value, start_date: value });
      }
      // If start date is more than 6 months before new end date, adjust start date
      else if (currentStartDate.isBefore(minStartDate)) {
        this.setState({
          end_date: value,
          start_date: minStartDate.format('YYYY-MM-DD'),
        });
      }
      // Otherwise just update end date
      else {
        this.setState({ end_date: value });
      }
    }
  };

  handleQuickSearch = (e) => {
    e.preventDefault();
    if (
      this.limitInput.current.value === '' ||
      this.limitInput.current.value === '0'
    ) {
      return;
    }
    this.setState(
      { limit: this.limitInput.current.value, offset: 1 },
      function () {
        this.getFuelPurchase();
      },
    );
  };

  resetFilter = () => {
    this.limitInput.current.value = 20;
    this.setState(
      {
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        loading: false,
        product_id: '',
        vendor_id: '',
        limit: 20,
        offset: 1,
      },
      function () {
        //this.getFuelPurchase();
      },
    );
  };
  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true, offset: 1 }, function () {
      this.getFuelPurchase();
    });
  };
  render() {
    const { purchaseList } = this.state;

    return (
      <section className="widget full-width list-table inverted">
        <header>
          <h3>Fuel Purchase Report</h3>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group">
                <label>Date range:</label>
                <DateRangeFilter
                  value={[this.state.start_date, this.state.end_date]}
                  onChange={(dates) => {
                    this.setState({
                      start_date: dates[0],
                      end_date: dates[1],
                    });
                  }}
                  limit={6}
                />
              </div>

              <div className="filter-group">
                <label> Fuel type:</label>
                <FuelList
                  onChange={this.handleProductChange}
                  value={this.state.product_id}
                />
              </div>
              <div className="filter-group">
                <label>Supplier name:</label>
                <VendorList
                  value={this.state.vendor_id}
                  onChange={this.handleVendorChange}
                />
              </div>
              <div className="filter-group with-icon">
                <label>
                  Results to display- {this.state.limit || 20} (Total:{' '}
                  {this.state.count})
                </label>
                <form onSubmit={this.handleQuickSearch}>
                  <input type="text" name="limit" ref={this.limitInput} />
                  <button
                    type="submit"
                    className="search-icon"
                    onClick={this.handleQuickSearch}
                  />
                </form>
              </div>
              <div className="filter-group reset-filter">
                <button onClick={this.resetFilter}>Reset filters</button>
              </div>
              <div className="filter-group">
                <button
                  className={`submit ${this.state.loading ? 'loading' : ''}`}
                  disabled={this.state.loading}
                  type="submit"
                  onClick={this.submitForm}
                >
                  Generate Report
                </button>
              </div>
            </div>
          </div>
          <div className="table-wrapper">
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <TableGrid
                    col={col}
                    row={purchaseList}
                    offset={this.state.offset}
                    count={this.state.count}
                    limit={this.state.limit}
                    handlePagination={this.handlePagination}
                    hideActions={true}
                    exportOptions={{
                      fileName: `Fuel Purchase - ${this.state.start_date} to ${this.state.end_date}.pdf`,
                      reportName: 'Fuel Purchase Report',
                      reportDate: `Date - ${dayjs(this.state.start_date).format(
                        'D MMM YY',
                      )} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                      reportTotal: `Total VAT -  ${
                        purchaseList
                          .reduce((a, b) => a + (b['vat'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportQuantity: `Total quantity -  ${
                        purchaseList
                          .reduce((a, b) => a + (b['total_quantity'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportSales: `Total additional VAT -  ${
                        purchaseList
                          .reduce((a, b) => a + (b['additional_vat'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportTesting: `Total reverse dealer commission -  ${
                        purchaseList
                          .reduce(
                            (a, b) => a + (b['reverse_dealer_commission'] || 0),
                            0,
                          )
                          .toFixed(2) || 0
                      }`,
                      reportBowser: `Total recovery for LFR/SSLF -  ${
                        purchaseList
                          .reduce(
                            (a, b) => a + (b['recovery_for_lfr_sslf'] || 0),
                            0,
                          )
                          .toFixed(2) || 0
                      }`,
                      reportCustomerName: '',
                      reportGst: '',
                      reportOpeningBalance: `Total amount -  ${
                        purchaseList
                          .reduce((a, b) => a + (b['base_amount'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportClosingBalance: `Total discount -  ${
                        purchaseList
                          .reduce((a, b) => a + (b['discount'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportSaleTotal: `Total sale amount -  ${
                        purchaseList
                          .reduce((a, b) => a + (b['amount'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportTCSTotal: `Total TCS amount -  ${
                        purchaseList
                          .reduce((a, b) => a + (b['tcs_amount'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                    }}
                  />
                );
              }
            })()}
            <div className="mini-summary">
              <ul>
                <li>
                  <span>Total amount: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      purchaseList.reduce(
                        (a, b) => a + (b['base_amount'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span>Total discount: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      purchaseList.reduce(
                        (a, b) => a + (b['discount'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span>Total VAT: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      purchaseList.reduce((a, b) => a + (b['vat'] || 0), 0) ||
                        0,
                    )}
                  </span>
                </li>
                <li>
                  <span>Total additional VAT: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      purchaseList.reduce(
                        (a, b) => a + (b['additional_vat'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span>Total reverse dealer commission: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      purchaseList.reduce(
                        (a, b) => a + (b['reverse_dealer_commission'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span>Total recovery for LFR/SSLF: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      purchaseList.reduce(
                        (a, b) => a + (b['recovery_for_lfr_sslf'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span>Total TCS amount: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      purchaseList.reduce(
                        (a, b) => a + (b['tcs_amount'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span>Total sale amount: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      purchaseList.reduce(
                        (a, b) => a + (b['amount'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span> Total quantity: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {}).format(
                      purchaseList.reduce(
                        (a, b) => a + (b['total_quantity'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </main>
      </section>
    );
  }
}

export { FuelPurchaseReport };
